// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"732":"fef21c02","977":"1e80a4a9"}[chunkId] + ".chunk.js");